import { createContext } from 'react';
export const FirebaseAuthContext = createContext(undefined);
